// extracted by css-extract-rspack-plugin
export default {"multifactorRoot":"K3U54E","input":"eEg68E"};